import { render, staticRenderFns } from "./SkinList.vue?vue&type=template&id=6fd993f2&scoped=true&"
import script from "./SkinList.vue?vue&type=script&lang=ts&"
export * from "./SkinList.vue?vue&type=script&lang=ts&"
import style0 from "./SkinList.vue?vue&type=style&index=0&id=6fd993f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd993f2",
  null
  
)

export default component.exports